export default __webpack_public_path__ + "static/5-c48983780a9069a0ba05c015ebbc74bc.jpg";